import { Extension } from '@tiptap/core';
import uploadDeviation from './uploadDeviation';
import { Plugin } from '@tiptap/pm/state';
export const DndUpload = Extension.create({
    name: 'dnd-upload',
    addCommands () {
        return {
            daUploadFile: (file)=>({ editor, dispatch, state })=>{
                    if (dispatch) {
                        // Insert the spinner
                        const { tr } = state;
                        tr.replaceSelectionWith(editor.schema.nodes.spinner.create());
                        dispatch(tr);
                        uploadDeviation({
                            file,
                            editor
                        }).then((deviation)=>{
                            const chain = editor.chain().focus();
                            chain.selectLastSpinner();
                            if (deviation) {
                                chain.daDeviationAddDeviation(deviation);
                            }
                            chain.run();
                        });
                    }
                    return true;
                }
        };
    },
    addProseMirrorPlugins () {
        return [
            new Plugin({
                props: {
                    handlePaste: (view, event)=>{
                        const { files = [] } = event.clipboardData || {};
                        const imageFile = files[0] && [
                            'image/jpg',
                            'image/jpeg',
                            'image/png',
                            'image/gif'
                        ].includes(files[0].type) ? files[0] : null;
                        if (imageFile) {
                            this.editor.commands.daUploadFile(imageFile);
                            return true; // We handled it
                        }
                        return false; // Let it pass through
                    }
                }
            })
        ];
    }
});

//# sourceMappingURL=dnd-upload.js.map